<template>
  <v-slide-y-transition>
    <v-sheet>
      <v-list two-line>
        <v-list-item
          v-for="item in appStore.getAlertItems"
          :key="item.id"
          class="pa-2"
          :prepend-icon="item?.status ? 'fasldr fa-triangle-exclamation' : undefined"
        >
          <v-list-item-title>
            <div class="text-error">
              {{ item?.name ? item?.name : item?.message }}
            </div>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ item?.time?.toUTCString() }}
          </v-list-item-subtitle>
          {{ item?.message ? item?.message : item?.stack }}
          <template #append>
            <v-btn
              icon="fasldr fa-xmark"
              variant="text"
              @click="removeAlert(item)"
            />
          </template>
        </v-list-item>
      </v-list>
    </v-sheet>
  </v-slide-y-transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAppStore } from '../stores/app'
import type { ErrorItem } from './Types'

const appStore = useAppStore()

function removeAlert(item: ErrorItem) {
  const toRemove = appStore.alertItems.find(a => a.id === item.id);
  if (toRemove) {
    appStore.alertItems.splice(appStore.alertItems.indexOf(toRemove), 1);
  }
}

</script>

<style>
.bouncy-slide-x-transition-enter-active,
.bouncy-slide-x-transition-leave-active,
.bouncy-slide-x-transition-move,
.bouncy-slide-x-reverse-transition-enter-active,
.bouncy-slide-x-reverse-transition-leave-active,
.bouncy-slide-x-reverse-transition-move {
  transition: transform, opacity;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
}

.bouncy-slide-x-transition-enter-from,
.bouncy-slide-x-transition-leave-to {
  opacity: 0;
  transform: translateX(-30%);
}

.bouncy-slide-x-reverse-transition-enter-from,
.bouncy-slide-x-reverse-transition-leave-to {
  opacity: 0;
  transform: translateX(30%);
}
</style>
